import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export const genericFilterParamValuesReducer = (state = initialState.genericFilterParamValues, action) => {
  const { key, context } = action;
  switch (action.type) {
    case types.LOAD_GENERICFILTERPARAMVALUES_STARTED: {
      let result = { ...state };
      result[context] = { ...state[context] };
      result[context][key] = {
        ...result[context][key],
        loading: true,
        loaded: false
      };
      return result;
    }
    case types.LOAD_GENERICFILTERPARAMVALUES_SUCCEEDED: {
      let result = { ...state };
      result[context] = { ...state[context] };
      result[context][key] = {
        ...result[context][key],
        ids: [...action.result],
        loading: false,
        loaded: true
      };
      return result;
    }
    case types.LOAD_GENERICFILTERPARAMVALUES_FAILED: {
      //return { ...state, [context]: { ...state[context], genericFilterParamValues: { loading: false, loaded: false } } };
      let result = { ...state };
      result[context] = { ...state[context] };
      result[context][key] = {
        ...result[context][key],
        loading: false,
        loaded: false
      };
      return result;
    }

    default:
      return state;
  }
};
